module.exports = __webpack_public_path__ + "img/base_patrimoine_art.13b656ae.svg";